import { getStorageByKey, setStorageValueByKey } from '@/utils/localStorage';

const KEY_STORAGE_CURRENCY = 'currency';

export const isCurrencyUsdByCode = (code = '') => {
  return code === 'USD';
};

export const isCurrencyRubByCode = (code = '') => {
  return code === 'RUB';
};

export const storageCurrency = {
  get: () => {
    return getStorageByKey(KEY_STORAGE_CURRENCY);
  },

  set: (value = false) => {
    setStorageValueByKey(KEY_STORAGE_CURRENCY, value);
  },
};
